import React from "react";
import Cookies from "universal-cookie";

import '../../../App.css';
import DoctorCard from '../Components/DoctorCard'
import CustomSearchTextField from "../Components/CustomSearchTextField";
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import AddDoctorModal from "../Components/AddDoctorModal";


const cookies = new Cookies();
export default function RegisteredDoctors(props) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
        const doctors=[
            true,false,true,true,false,true,false,false,false,true,true,false,true,true,false,true,false,false,false,true,
        ]

        if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '3') {
            return (
                <>
                <AddDoctorModal open={open} handleClose={handleClose} handleOpen={handleOpen} />
                <div className="visa-master-payment-dashboard-div" style={{ color: '#2E5266FF' }}>
                    <h3 style={{marginTop:'10px',color:'#59776E'}}>  ألاطباء المسجلين</h3>
                    <div style={{display:'flex',flexDirection:'row',width:'85%',marginBottom:20}}>
                        <div style={{flex:1,}}>
                        </div>
                        <div style={{flex:1,justifyContent:'center',display:'flex',alignItems:'center'}}>
                            <div style={{marginTop:'10px',height:'40px',width:'100%',boxShadow:'#00000033 0px 3px 6px',borderRadius: '20px',}}>
                                <CustomSearchTextField icon={<SearchIcon />} label={"البحث عن طبيب .."} />
                            </div>
                        </div>
                        <div style={{flex:1,justifyContent:'end',display:'flex',alignItems:'center'}}>
                            <div style={{marginTop:'10px',height:'40px',width:'100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'end'
                            }}>
                        <Button variant="contained"
                        startIcon={<AddIcon 
                            style={{ fontSize: 30 , marginLeft:10 }}  />}
                        onClick={() => { setOpen(true) }}
                        sx={{
                            fontFamily: " 'Tajawal', sans-serif",
                            backgroundColor: '#59776E',
                            color: '#fff',
                            height:'100%',
                            boxShadow:'#00000033 0px 3px 6px',
                            fontSize: '20px',
                            paddingTop: 0,
                            paddingBottom: 0,
                            

                            '&:hover': {
                                backgroundColor: '#FFFFFF',
                                color: '#59776E',
                            },
                            borderRadius: '20px',
                            borderColor: '#707070',
                            borderWidth: 1,
                            borderStyle: 'solid',
                            
                        }}>
                        أضافة طبيب
                        </Button>
                        </div>
                
                        </div>
                    </div>
                    
                <div className="mohscroll" style={{
                    display: 'flex',
                    flexFlow: 'row-reverse wrap',
                    alignItems:'stretch',
                    justifyContent:'center',
                    overflowY: 'scroll',
                    paddingTop:'20px',
                    height:'90vh'
                }}>
                    {doctors.map(doctor=><DoctorCard paid={doctor} />)}
                </div>
                
                </div>
                </>
            );
        } else {
            window.location.href = "/"
        }
    
}

